import qs from 'query-string'

/**
 * 获取url的query参数键值对
 */
export function getUrlSearchValue() {
  return qs.parse(window.location.search)
}

export function getDecodeValue(data: string | (string | null)[] | null) {
  return typeof data === 'string'
  ? decodeURIComponent(data)
  : decodeURIComponent(data?.[0] || '')
}


export function extendsUrlSearch(params: {
  [key: string]: any
}) {
  const strParams = qs.stringify(params)
  return window.location.search.startsWith('?') ? `${window.location.search}&${strParams}` : `?${strParams}`
}

const ua = window.navigator.userAgent.toLowerCase();
const isQQ = /mqqbrowser|qqtheme/.test(ua)
export const isIOS = /iphone|ipad|ipod|macintosh|mqqbrowser/.test(ua) || isQQ;

export const goToLogin = () => {
  location.href = `https://ke.youdao.com/wap/login?back_url=${encodeURIComponent(location.href)}`
}
